import { render } from "./ModelsComponent.vue?vue&type=template&id=214d6443"
import script from "./ModelsComponent.vue?vue&type=script&lang=js"
export * from "./ModelsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__